module.exports = __webpack_public_path__ + "static/laboheme7-fa325e4c82929208e9093dd74482eacd.jpg";